import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

import SwitchButton from "components/SwitchButton";

type FocusedSwitchProps = {
  checked?: boolean;
  onSwitch?: (_checked: boolean) => void;
  tooltip?: React.ReactNode;
};

const FocusedSwitch = ({ checked, onSwitch, tooltip }: FocusedSwitchProps) => {
  return (
    <OverlayTrigger
      placement="top"
      overlay={tooltip ? <Tooltip>{tooltip}</Tooltip> : <></>}
    >
      <div>
        <SwitchButton
          checked={checked}
          onClick={() => onSwitch && onSwitch(!checked)}
        >
          Focused
        </SwitchButton>
      </div>
    </OverlayTrigger>
  );
};

export default FocusedSwitch;
